var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarToday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar_today"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/action/calendar_today_24px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.334 1.99935H12.6673V0.666016H11.334V1.99935H4.66732V0.666016H3.33398V1.99935H2.66732C1.93398 1.99935 1.33398 2.59935 1.33398 3.33268V13.9993C1.33398 14.7327 1.93398 15.3327 2.66732 15.3327H13.334C14.0673 15.3327 14.6673 14.7327 14.6673 13.9993V3.33268C14.6673 2.59935 14.0673 1.99935 13.334 1.99935ZM13.334 13.9993H2.66732V6.66602H13.334V13.9993ZM2.66732 5.33268H13.334V3.33268H2.66732V5.33268Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarToday);
export default __webpack_public_path__ + "static/media/calendar_today.31d3eceff355e6c7754476e6124b5efb.svg";
export { ForwardRef as ReactComponent };